export const iconFontAwesomeHalloweenMask = (
	<i className="fa-solid fa-mask"></i>
);
